import { Checkbox } from '@kizi/shared-components';
import React, { useEffect, useState } from 'react';
import { withFormProps } from './HOCs';
import { useField } from '@kizi/comparator-core';

const FormCheckbox = withFormProps(Checkbox, {
  _containerProps: {
    variant: 'formGroupInlineReversed',
    alignContent: 'center',
  },
});

export const ToggleVisibleProductsCheckbox = ({ fieldName, _label }) => {
  const sortTypeField = useField(fieldName);
  const [checked, setChecked] = useState(
    JSON.parse(sortTypeField?.value as string) ?? false
  );

  useEffect(() => {
    sortTypeField?.set({ value: JSON.stringify(checked) });
  }, [checked]);

  return (
    <FormCheckbox
      variant="main"
      _label={_label}
      _labelProps={{ variant: 'sideLabel' }}
      checked={checked}
      onChange={(e) => setChecked(e.target.checked)}
    />
  );
};
